import loader from "../../../assets/gif/newgifs/loader.gif";
import { memo } from "react";
import { redBtnCls } from "../../../common/constants";
import BtnDisableTooltip from "../../../viewpages/newpages/teamModule/component/BtnDisableTooltip";
import close from "../images/Union (2).svg";
let greyBtnCls = "text-small  swal-alert font-weight-bold round-btn swal-cencle-color mx-4";
let blueBtnCls = "bg-prime text-white text-small swal-text swal-delet-box round-btn  font-weight-bold mx-4";

const SwalAlert = (props) => {
   const {
      alertclass,
      titleText,
      contentText,
      titleView,
      contentView,
      confirmText,
      cancelText,
      showLoader,
      onAction,
      onClose,
      showButton = false,
      showClose = true,
      message = false,
      confirmcls = "",
      cancelcls = "",
      createTeamList,
      teamSection,
      createNewTeam,
      deletedTeam,
      className,
      createClassName,
      textClass,
      xbuttonClass,
      createTeamBtn,
      confirmButtonId = null,
      confirmButtonText = null,
      cancelButtonId = null,
      from = "",
      inviteCls = "",
      buttons = [
         !message && {
            id: "alert-cancel-button",
            className: `${greyBtnCls} ${cancelcls} ${inviteCls}  m-3`,
            text: "Cancel",
         },
         {
            id: confirmButtonId ? confirmButtonId : "alert-confirm-button",
            className: `${blueBtnCls} ${confirmcls} ${inviteCls}  m-3`,
            text: confirmButtonText ? confirmButtonText : "Discard",
         },
      ],
      checkRole = true,
      boldText = "",
      contentText2 = "",
      invite = false,
      isPaymentGateway = false,
   } = props;
   const getButtonText = (button) => {
      if (button.id === "alert-cancel-button" && cancelText) {
         return cancelText;
      } else if (button.id === "alert-confirm-button" && confirmText) {
         return confirmText;
      } else {
         return button.text;
      }
   };
   const handleCloseFun = () => {
      onClose();
   };

   return (
      <div className={`AlertView bg-white ${alertclass}`}>
         <div className={`alert-title-div w-100 d-flex justify-content-end  ${createClassName}`}>
            {titleView ? (
               titleView()
            ) : (
               <h2 className={` alert-header-text custom-new-truncate ${invite && "margin-custom"} w-100 ${textClass}`}>
                  {titleText}
               </h2>
            )}
            {!showClose ? (
               <img
                  className={`h1 m-0 
               ${invite && "alert-close-position"} pointer flex-center position-absolute ${xbuttonClass}`}
                  onClick={handleCloseFun}
                  src={close}
                  alt="close"
               />
            ) : null}
         </div>
         {isPaymentGateway ? (
            <div className="alert-content-div w-100 px-5 mb-4">
               <div className="my-5 content-text">
                  {contentText} <strong>{boldText}</strong> {contentText2}
               </div>
            </div>
         ) : (
            <div style={{ height: !showButton ? "60px" : "85px" }} className="alert-content-div w-100 px-5 mb-4">
               {contentView ? (
                  contentView()
               ) : (
                  <div className="my-4 content-text">
                     {contentText} <strong>{boldText}</strong> {contentText2}
                  </div>
               )}
            </div>
         )}
         <div className={`alert-actions-div w-100 flex-center ${className} ${createTeamBtn}`}>
            {showLoader ? (
               <div className="w-100 flex-center mt-5">
                  <img width="40px" height="40px" src={loader} alt="" />
               </div>
            ) : createTeamList ? (
               <button
                  id={confirmButtonId ? confirmButtonId : "alert-confirm-button"}
                  className={`${blueBtnCls} ${confirmcls} m-2`}
                  onClick={createNewTeam}
               >
                  {confirmButtonText ? confirmButtonText : "Create team"}
               </button>
            ) : teamSection ? (
               <div className="d-flex flex-column">
                  <button
                     id={confirmButtonId ? confirmButtonId : "alert-confirm-button"}
                     className={`${blueBtnCls} ${confirmcls} m-2`}
                     onClick={() => onAction && onAction()}
                  >
                     Update
                  </button>
                  <button
                     id={cancelButtonId ? cancelButtonId : "alert-cancel-button"}
                     className={`${redBtnCls} ${cancelcls} m-2`}
                     onClick={deletedTeam}
                     style={{ marginTop: "-2px !important" }}
                  >
                     Delete
                     <BtnDisableTooltip checkMemberRole={checkRole} />
                  </button>
               </div>
            ) : (
               buttons.map((btn) => (
                  <button
                     key={btn.id}
                     onClick={() => {
                        if (from === "content" && btn.id === "alert-cancel-button") {
                           onClose && onClose(btn);
                        }
                        onAction && onAction(btn);
                     }}
                     id={btn.id}
                     {...btn}
                  >
                     {getButtonText(btn)}
                  </button>
               ))
            )}
         </div>
      </div>
   );
};

export default memo(SwalAlert);
